import { createFeature, createReducer, on, select } from '@ngrx/store';
import { createEntityAdapter } from '@ngrx/entity';
import { ContractId, ContractList, ContractsEntityState, ContractsAdapter } from '../../interfaces';
import * as PaymentMethodActions from '../payment-method/payment-method.actions';
import * as contractsActions from './contracts.actions';

export const ContractsFeatureAdapter: ContractsAdapter = createEntityAdapter({
    selectId: (e) => e.id,
});

const initialState: ContractsEntityState =
    ContractsFeatureAdapter.getInitialState({
        loaded: false,
        hasSelected: false,
        selected: '',
    });

export const ContractsFeatureName: any = 'Contract List';

const LoadContractsAction: any =
    (state: ContractsEntityState) => ({ ...state, loaded: initialState.loaded });

const ResetContractsAction: any =
    (state: ContractsEntityState) => ContractsFeatureAdapter.removeAll({ ...state, loaded: initialState.loaded, hasSelected: initialState.hasSelected, selected: initialState.selected });

const ResetContractSelectedIdAction: any =
    (state: ContractsEntityState) => ({ ...state, hasSelected: initialState.hasSelected, selected: initialState.selected });

const SetContractsAction: any =
    (state: ContractsEntityState, { list }: ContractList) => ContractsFeatureAdapter.setAll(list, { ...state, loaded: true });

const SetContractSelectedIdAction: any =
    (state: ContractsEntityState, { id }: ContractId) => ({ ...state, hasSelected: !initialState.hasSelected, selected: id });

/**
 * A card she just saved makes that lease `ACTIVE`, whatever the list said at login (OPS-2288).
 *
 * The lease list is a snapshot taken once; this is the one moment the portal knows better than
 * the snapshot, and writing it here is what stops the nudge in the same session she acts on it
 * — no re-fetch, no re-login.
 *
 * `ACTIVE` and not merely "has a card": a method tokenized moments ago has no charge history,
 * so nothing about it has failed. That also clears a stale `FAILED` from the card this one
 * replaced, which is the whole point of her being here — a ROSE told her card was declined,
 * who then adds a new one, must not still be told her card was declined.
 */
const SetLeaseBackupActiveAction: any =
    (state: ContractsEntityState, { leaseKey }: { leaseKey: string }) =>
        ContractsFeatureAdapter.updateOne(
            { id: leaseKey, changes: { backupPaymentStatus: 'ACTIVE' } },
            state
        );

export const ContractsFeature = createFeature({
    name: ContractsFeatureName,
    reducer: createReducer(
        initialState,
        on(contractsActions.LoadContractsAction, LoadContractsAction),
        on(contractsActions.ResetContractsAction, ResetContractsAction),
        on(contractsActions.ResetContractSelectedIdAction, ResetContractSelectedIdAction),
        on(contractsActions.SetContractsAction, SetContractsAction),
        on(contractsActions.SetContractSelectedIdAction, SetContractSelectedIdAction),
        on(PaymentMethodActions.saveBackupMethodSuccess, SetLeaseBackupActiveAction)
    ),
});
